<!-- eslint-disable vue/no-deprecated-slot-attribute -->
<template>
  <div class="bottom-navigation" :class="{ 'is-hidden': isHidden }">
    <div class="container">
      <div class="bottom-navigation-wrapper">
        <div class="d-flex align-items-center justify-content-between">
          <div
            class="list-categories d-flex align-items-center"
            style="gap: 20px"
          >
            <div class="d-flex" style="gap: 10px">
              <div
                class="btn-group"
                @mouseenter="mouseEnterHandler"
                @mouseleave="mouseLeaveHandler"
              >
                <button
                  class="menu-trigger-button"
                  type="button"
                  aria-expanded="false"
                >
                  <span class="mr-2">
                    <i class="fi fi-br-menu-burger"></i>
                  </span>
                  <div class="d-flex m-hidden">
                    <span class="mr-1">Categories</span>
                    <i class="fi fi-rs-angle-small-down"></i>
                  </div>
                </button>
              </div>
            </div>
            <div class="vl" />
            <div class="categories-containers">
              <span
                class="categories-items"
                v-for="item in categ"
                :key="item.slug"
                role="buttton"
              >
                <router-link
                  :to="{
                    name: 'product-category',
                    params: { category: item.uuid },
                  }"
                >
                  {{ item.name }}
                </router-link>
              </span>
            </div>
          </div>
          <div class="d-flex align-items-center" style="gap: 20px">
            <div>
              <el-dropdown>
                <span class="el-dropdown-link">
                  Earn on SellersMart
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <a href="https://vendors.sellersmart.ng" target="__blank"
                      >Become a Vendor</a
                    >
                  </el-dropdown-item>
                  <el-dropdown-item
                    ><a
                      href="https://affiliates.sellersmart.ng"
                      target="__blank"
                      >Become an Affiliate</a
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="vl" />
            <div>
              <el-dropdown>
                <span class="el-dropdown-link">
                  English - {{ userLocation?.currency_code }}
                  <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
                </span>
              </el-dropdown>
            </div>

            <div class="d-flex align-items-center">
              <span class="categories-items mr-1">
                <i class="fi fi-bs-marker"></i>
              </span>
              <span class="categories-items">{{ userLocation?.city }}</span>
            </div>
          </div>
        </div>
        <DropDownNavigation
          v-show="isDropdownShow"
          :categories="allcateg"
          :isLoading="isLoadingCategories"
          @mouseenter="clearMouseLeaveTimeout"
          @mouseleave="mouseLeaveHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DropDownNavigation from "./dropDownNavigation.vue";

import { useQuery } from "@tanstack/vue-query";
import { mapState } from "vuex";
import { ref } from "vue";

const allCategories = async () => {
  let res = await axios.get("products/categories?withProductLine=true");
  return res.data.data;
};

const getCategories = async () => {
  let res = await axios.get("products/categories");
  return res.data.data.slice(0, 4);
};

export default {
  components: { DropDownNavigation },
  computed: {
    ...mapState(["userLocation"]),
  },
  data() {
    return {
      categories: [
        {
          id: 1,
          name: "Deals",
          url: "/",
        },
        {
          id: 2,
          name: "Health & Beauty",
          url: "/",
        },
        {
          id: 3,
          name: "Phones & Tablets",
          url: "/",
        },
        {
          id: 4,
          name: "Electronics",
          url: "/",
        },
        {
          id: 5,
          name: "Fashion",
          url: "/",
        },
        {
          id: 6,
          name: "Home & Office",
          url: "/",
        },
      ],
      isHidden: false,
      lastScrollPosition: 0,
      hideTimer: null,
      delay: 500,
      offset: 100,
      mouseLeaveTimer: null,
      isDropdownShow: false,
    };
  },
  setup() {
    const showSub = ref("");
    const subList = ref([]);

    const allCategoryQuery = useQuery({
      queryKey: ["allcategories"],
      queryFn: allCategories,
      retry: 1,
      keepPreviousData: true,
      staleTime: Infinity,
    });

    const CategoryQuery = useQuery({
      queryKey: ["categories"],
      queryFn: getCategories,
      retry: 1,
      keepPreviousData: true,
      staleTime: Infinity,
    });

    const allcateg = allCategoryQuery.data;
    const categ = CategoryQuery.data;
    const isLoadingCategories = CategoryQuery.isLoading;

    return { categ, allcateg, showSub, subList, isLoadingCategories };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    clearTimeout(this.mouseLeaveTimer);
  },
  methods: {
    handleScroll() {
      const currentScrollPosition = window.scrollY;

      if (currentScrollPosition < this.offset) {
        this.resetHideTimer();
        this.isHidden = false;
        return;
      }

      if (currentScrollPosition > this.lastScrollPosition) {
        if (!this.hideTimer) {
          this.hideTimer = setTimeout(() => {
            this.isHidden = true;
          }, this.delay);
        }
      } else {
        this.resetHideTimer();
        this.isHidden = false;
      }

      this.lastScrollPosition = currentScrollPosition;
    },
    resetHideTimer() {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
    },
    debounce(func, wait) {
      let timeout;
      return function (...args) {
        const later = () => {
          clearTimeout(timeout);
          func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    mouseEnterHandler() {
      this.isDropdownShow = true;
      clearTimeout(this.mouseLeaveTimer);
    },
    mouseLeaveHandler() {
      this.mouseLeaveTimer = setTimeout(() => {
        this.isDropdownShow = false;
      }, 500);
    },
    clearMouseLeaveTimeout() {
      clearTimeout(this.mouseLeaveTimer);
    },
  },
};
</script>

<style scoped>
.mega-menu-dropdown {
  max-height: 450px;
  overflow: auto;
}
.mega-menu-dropdown .dropdown-item:hover {
  background-color: transparent;
}
.category .icon {
  margin-right: 0.25rem;
}
.category:hover .icon {
  margin-right: 0;
}
.drop {
  padding: 0rem 1.5rem;
}
.all {
  padding: 0rem 1.5rem;
}
.all div {
  margin: 0.5rem 0 !important;
  cursor: pointer;
}
.all:hover {
  background-color: aqua;
}
.drop p {
  margin: 0.5rem 0 !important;
  cursor: pointer;
  padding: 0.35rem !important;
}
.drop p:hover {
  color: var(--primary-color);
}
a {
  color: inherit;
  text-decoration: none;
  text-decoration-color: inherit;
}
a:hover {
  color: inherit;
}
</style>
